import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

/**
 * Accessible FAQ accordion. The page-level Seo component emits the
 * corresponding FAQPage JSON-LD; this component only renders the visual UI.
 *
 * Props:
 *   faqs: [{ q, a }]
 */
const FAQAccordion = ({ faqs }) => {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <div className="space-y-3" data-testid="faq-accordion">
      {faqs.map((faq, idx) => {
        const isOpen = openIdx === idx;
        return (
          <div
            key={idx}
            className={`border rounded-lg transition-colors ${isOpen ? 'border-amber-500/40 bg-gray-900/60' : 'border-gray-800 bg-gray-900/30 hover:border-gray-700'}`}
          >
            <button
              type="button"
              onClick={() => setOpenIdx(isOpen ? -1 : idx)}
              className="w-full flex items-center justify-between gap-4 px-5 py-4 text-left"
              data-testid={`faq-toggle-${idx}`}
            >
              <span className="text-white font-medium">{faq.q}</span>
              <ChevronDown className={`w-5 h-5 text-amber-500 shrink-0 transition-transform ${isOpen ? 'rotate-180' : ''}`} />
            </button>
            {isOpen && (
              <div className="px-5 pb-5 text-gray-300 leading-relaxed text-sm" data-testid={`faq-answer-${idx}`}>
                {faq.a}
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default FAQAccordion;
